import React from 'react';
import { Typography } from 'fronton-react';
import { css } from 'linaria';
import { media } from '../../../../../media';

const PageAdditionalInfoStyles = css`
	margin-top: 80px;
	${media.mobile} {
		margin-top: 72px;
	}
`;

export const PageAdditionalInfo = () => (
	<Typography
		as="p"
		variant="m"
		size="body_long"
		color="text-secondary"
		className={PageAdditionalInfoStyles}
		overrideStyles={false}
	>
		Магазин оказывает услуги только на товар, приобретенный в этом магазине.
		<br />
		Условия предоставления услуг в магазинах могут отличаться.
	</Typography>
);
